export default __webpack_public_path__ + "static/media/four.4663a2c5.svg";